export const consultationListWithValue = [
  {
    name: "All",
    value: "all",
    type: "consultation",
  },
  {
    name: "Tele-Consult Regular",
    value: "online-regular",
    type: "consultation",
  },
  {
    name: "Tele-Consult Follow-Up",
    value: "online-followup",
    type: "consultation",
  },
  {
    name: "In-Clinic Regular",
    value: "inclinic-regular",
    type: "consultation",
  },
  {
    name: "In-Clinic Follow-Up",
    value: "inclinic-followup",
    type: "consultation",
  },
  {
    name: "Instant",
    value: "instant",
    type: "consultation",
  },
];

export const appointmentStatusListwithValue = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Upcoming",
    value: "upcoming",
  },
  {
    name: "Completed",
    value: "completed",
  },
  {
    name: "Rescheduled By Me",
    value: "reschedule_self",
  },
  {
    name: "Rescheduled By Staff",
    value: "reschedule_staff",
  },
  {
    name: "Patient Rescheduled",
    value: "reschedule_patient",
  },
  {
    name: "Cancelled By Me",
    value: "cancel_self",
  },
  {
    name: "Cancelled By Staff",
    value: "cancel_staff",
  },
  {
    name: "Patient Cancelled",
    value: "cancel_patient",
  },
  {
    name: "No Show",
    value: "no_show",
  },
];
